import {Component, Inject, Input, OnInit} from '@angular/core';
import {FormBuilder, Validators} from "@angular/forms";
import { StateService } from '@uirouter/core';
import {confirmValidator} from '../confirm-validator';
import {requiredTrim} from '../trim-validator';
import {LocalStorageService} from "angular-2-local-storage";
import {ApiService} from "../../utils/api.service";
import {WindowRefService} from "../../utils/window.service";
import {FormService} from "../../utils/form.service";
import {AppService} from "../../utils/app.service";
import {AnalyticsService} from "../../utils/analytics.service";
@Component({
    selector: 'sign_up-page',
    template: require('./sign_up.html'),
})

export class  SignUpPageComponent implements OnInit{
    private _window: any;
    public phoneMask = ['(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

    private signUpForm = {
        form: null,
        $submitting: false,
        $visible: false,
        $errorMsg:'',

        username: '',
        password: '',
        password_confirm:'',
        first_name:'',
        last_name:'',
        phone:'',

        client_id:'',
        client_secret:'',
        response_type:'',
        redirect_uri:'',
        accept_terms: null,
        promo: null,

        utm_campaign:'',
        utm_content:'',
        utm_medium:'',
        utm_source:'',
        utm_term:'',
        gclid:''
    };
    @Input() params : any;
    @Input() config : any;
    constructor(
        @Inject(AppService) private app: any,
        @Inject(ApiService) private api: any,
        @Inject(AnalyticsService) private Analytics: any,
        @Inject(FormService) private Form: any,
        private localStorageService: LocalStorageService,
        windowRef: WindowRefService,
        private Location:StateService,
        @Inject(FormBuilder) private fb:FormBuilder
    ){
        this._window = windowRef.nativeWindow;
        this.signUpForm.form = this.fb.group({
            username: [this.signUpForm.username, [
                Validators.required,
                Validators.email
            ]],
            password: [this.signUpForm.password, [
                Validators.required,
            ]],
            password_confirm: [this.signUpForm.password_confirm, [
                Validators.required,
                confirmValidator('password')
            ]],
            phone: [this.signUpForm.phone, [
                Validators.required,
            ]],
            first_name: [this.signUpForm.first_name, [
                Validators.required,
                requiredTrim()
            ]],
            last_name: [this.signUpForm.last_name, [
                Validators.required,
                requiredTrim()
            ]],
            accept_terms: [this.signUpForm.accept_terms, [
                Validators.requiredTrue,

            ]]
        });
    }

    ngOnInit(){
        this.app.config = this.config;

        if(this.params && this.params.client_id) {
            this.localStorageService.set('params', this.params);
        }else if (!this.params || !this.params.client_id){
            this.app.setDefaultParams();
        }

        let authParams = <any>this.localStorageService.get('params');
        this.signUpForm.client_id       = authParams.client_id;
        this.signUpForm.client_secret   = authParams.client_secret;
        this.signUpForm.response_type   = authParams.response_type;
        this.signUpForm.redirect_uri    = authParams.redirect_uri;
        this.signUpForm.promo           = authParams.promo;

        let utmParams = JSON.parse(localStorage.getItem('query'));
        if(utmParams){
            this.signUpForm.utm_campaign  = utmParams.utm_campaign;
            this.signUpForm.utm_content   = utmParams.utm_content;
            this.signUpForm.utm_medium    = utmParams.utm_medium;
            this.signUpForm.utm_source    = utmParams.utm_source;
            this.signUpForm.utm_term      = utmParams.utm_term;
            this.signUpForm.gclid         = utmParams.gclid;
        }
    }

    isRegistrationError(response) {
        if (response.status === 403) {
            let data = response.error || response.data;
            if (data.password_is_valid) {
                this.signUpForm.$submitting = true;
                this.app.login(this.signUpForm);
            } else {
                this.Analytics.trackEvent('Sign Up', 'Error', 'This email is already registered');
                this.signUpForm.$errorMsg = 'This email is already registered!<br/>'
                    + '<a href="#/login?username=' + this._window.encodeURIComponent(this.signUpForm.username) + '">Sign In</a>';
            }
            return true;
        } else if (response.status === 400) {
            this.Analytics.trackEvent('Sign Up', 'Error', 'Invalid Information');

            return true;
        } else {
            return false;
        }

    };
    onSignUp_Success(response) {
        if (!this.isRegistrationError(response)) {
            this.signUpForm.$submitting = true;
            this.registerUser();
        }
    };

    onSignUp_Error(response) {
        if (!this.isRegistrationError(response)) {
            this.Location.go('error500');
        }
    };

    onSignUp_Invalid() {
        this.Analytics.trackEvent('Sign Up', 'Error', 'Provide required information');
    };

    signUp_Check() {
        this.signUpForm.phone = this.signUpForm.phone.replace(/[^0-9]/g,'');
        this.Form.submit(
            this.signUpForm,
            this.api.registerUserCheck.bind(this.api),
            this.onSignUp_Success.bind(this),
            this.onSignUp_Error.bind(this),
            this.onSignUp_Invalid.bind(this)
        );
    };

    onRegister() {
        this.signUpForm.$submitting = true;
        this.Analytics.trackEvent('Sign Up', 'Finish');
        //this.app.login(this.signUpForm);
        this.Location.go('login', {username: this.signUpForm.username});
    };

    registerUser() {
        this.Form.submit(
            this.signUpForm,
            this.api.registerUser.bind(this.api),
            this.onRegister.bind(this),
            null,
            this.onSignUp_Invalid.bind(this)
        );
    };

    checkPhone(){
        if (this.signUpForm.phone && this.signUpForm.phone.replace(/[^0-9]/g,'').length===10){
            this.signUpForm.phone = this.signUpForm.phone.replace(/[^0-9]/g,'');
            return true;
        }else{
            this.signUpForm.phone = '';
            return false;
        }
    }
}
